import type { VariantLoadingTextProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass, LOADING_DOT } from '../helper';
import '../index.less';

function TextDotsLoading({ text = 'Thinking', className, size = 'md' }: VariantLoadingTextProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__text-dots-container', className)}>
      <span className={cn('wg-variant-loading__text-dots-text', getSizeClass(size))}>{text}</span>
      <span className="wg-variant-loading__text-dots-dots">
        <span className="wg-variant-loading__dot" style={{ animationDelay: '200ms' }}>
          {LOADING_DOT}
        </span>
        <span className="wg-variant-loading__dot" style={{ animationDelay: '400ms' }}>
          {LOADING_DOT}
        </span>
        <span className="wg-variant-loading__dot" style={{ animationDelay: '600ms' }}>
          {LOADING_DOT}
        </span>
      </span>
    </div>
  );
}

const TextDotsLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingTextProps>(TextDotsLoading);
TextDotsLoadingComponent.displayName = 'TextDotsLoading';

export default TextDotsLoadingComponent;
